import { MessageCircle } from "lucide-react";
import { buildWaLink } from "../lib/api";

export const WhatsAppFloat = ({ number }) => {
    if (!number) return null;
    return (
        <a
            data-testid="whatsapp-float"
            href={buildWaLink(number, "")}
            target="_blank"
            rel="noreferrer"
            aria-label="Falar no WhatsApp"
            className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#FF6A00] pl-4 pr-5 py-3 font-condensed font-bold uppercase tracking-widest text-sm text-black shadow-[0_0_30px_rgba(255,106,0,0.35)] transition-colors hover:bg-[#FF8533]"
        >
            <MessageCircle size={20} strokeWidth={2.5} />
            WhatsApp
        </a>
    );
};
